import { Box, BoxProps, IconButton } from '@material-ui/core';

import { Icon } from '@/components/shared/components/Icon';

interface LastItemSelectorWrapperProps {
  children: JSX.Element;
  removeItem?: () => void;
  boxProps?: BoxProps;
}

export const LastItemSelectorWrapper = ({ children, boxProps, removeItem }: LastItemSelectorWrapperProps) => {
  return (
    <Box
      display={'flex'}
      flexDirection={'row'}
      gridGap={8}
      alignItems={'center'}
      justifyContent={'space-between'}
      minWidth={'200px'}
      width={'100%'}
      {...boxProps}
    >
      {children}
      {removeItem && (
        <IconButton
          size={'small'}
          onClick={(e) => {
            e.stopPropagation();
            removeItem();
          }}
          style={{ textAlign: 'right' }}
        >
          <Icon size={20}>delete</Icon>
        </IconButton>
      )}
    </Box>
  );
};
